<template>
    <div class="lw-course-contents-arrow left-arrow full-height lw-hide-sp" @click="emitAction('action-triggered',template)"  v-show="display">
        <span class="learnworlds-icon large fas fa-angle-left pos-abs center"></span>
    </div>

</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "SliderBackArrow",
        mixins: [ComponentTemplatesMixin],
        props: {
            display: {
                type: Boolean
            },
            template: {
                type: String
            }
        },
    }
</script>

